import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

const PaymentLoading = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");

  // useEffect(() => {
  //   const formData = new FormData(document.forms[0]);
  //   const encResp = formData.get("encResp");

  //   console.log("encResp: ", encResp);

  //   fetch("https://portal.acrossassist.com/api/GetDmiPaymentResponse", {
  //     method: "POST",
  //     body: JSON.stringify({ encResp }),
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   });
  // }, []);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const MAX_ATTEMPTS = 5;
    const POLL_INTERVAL = 2000;
    let attempts = 0;
    let timeoutId;

    const getDmiPaymentResponseApi = async () => {
      attempts += 1;
      try {
        const res = await axios(
          `https://portal.acrossassist.com//api/partner/v1/dmi/GetPaymentStatusByUserId?UserId=${userId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          },
        );

        if (res?.data?.data?.order_status === "Success") {
          navigate("/payment-success");
          return;
        }

        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(getDmiPaymentResponseApi, POLL_INTERVAL);
        } else {
          toast.error(res?.data?.status_message);
          navigate("/payment-failure");
        }
      } catch {
        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(getDmiPaymentResponseApi, POLL_INTERVAL);
        } else {
          navigate("/payment-failure");
        }
      }
    };

    getDmiPaymentResponseApi();

    return () => clearTimeout(timeoutId);
  }, [userId, navigate]);

  return (
    <Container
      fluid
      className="d-flex vh-100 justify-content-center align-items-center bg-light"
    >
      <Row>
        <Col xs={12} className="text-center">
          <Spinner
            role="status"
            variant="primary"
            animation="border"
            style={{ width: "4rem", height: "4rem" }}
          />
          <h3 className="mt-4">Processing Your Payment...</h3>
          <p className="text-muted">Please do not refresh the page.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentLoading;
